import React, {useRef} from "react";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileUpload} from "@fortawesome/free-solid-svg-icons";
import { Tooltip as ReactTooltip } from "react-tooltip";

import styles from "./Buttons.module.scss";

UploadFile.propTypes = {
    handler: PropTypes.func,
    tip: PropTypes.string,
    id: PropTypes.string,
    accept: PropTypes.string,
}

function UploadFile(props) {
    const {id, handler, tip, accept = '.json'} = props;
    const inputRef = useRef()

    const handleSelect = (e)=>{
        handler(e)
        inputRef.current.value = '';
    }

    return (
        <>
            <ReactTooltip id={`${id}-upload-tooltip`} delayShow={500}/>
            <div style={{display:"flex",alignItems:"center"}} data-tooltip-id={`${id}-upload-tooltip`} data-tooltip-content={tip}>
                <label htmlFor={id}>
                    <div className={styles.wrapper}>
                        <FontAwesomeIcon
                            style={{color: "white"}}
                            className={styles.icon}
                            icon={faFileUpload}/>
                    </div>
                </label>
            </div>
            <input ref={inputRef} style={{display: "none"}} id={id} type='file' accept={accept} onChange={handleSelect}/>
        </>
    )
}

export default UploadFile;